import React, { useState } from 'react';
import { ArrowRight, ShieldCheck, Check } from 'lucide-react';
import { useDolarBlue } from '../../hooks/useDolarBlue';
function ProductMockup() {
  return <div className="relative w-full max-w-lg mx-auto mb-10 select-none" data-id="element-182">
      <img src="https://cdn.magicpatterns.com/uploads/rHE2eGbckRrpvuA5ywqQRi/recetas_ancestrales_PDF_1_-Photoroom.png" alt="Manual de Sanación Natural + Bonos (PDF)" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-183" />
    </div>;
}
function PaymentLogos() {
  return <div className="flex flex-wrap items-center justify-center gap-3 mt-5" data-id="element-184">
      {/* Mercado Pago */}
      <div className="flex items-center gap-1.5 bg-[#009EE3] px-3 py-1.5 rounded-lg" data-id="element-185">
        <img src="https://cdn.magicpatterns.com/uploads/mb86qyhGxtkVh8xoonjKP8/channels4_profile.jpg" alt="Mercado Pago" className="w-5 h-5 rounded-full object-cover" data-id="element-186" />
        <span className="text-white text-xs font-bold tracking-wide" data-id="element-187">
          Mercado Pago
        </span>
      </div>
      {/* Visa */}
      <div className="flex items-center bg-white px-3 py-1.5 rounded-lg" data-id="element-188">
        <span className="font-black text-[#1A1F71] text-sm italic tracking-tight" data-id="element-189">
          VISA
        </span>
      </div>
      {/* Mastercard */}
      <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-lg" data-id="element-190">
        <div className="w-5 h-5 rounded-full bg-[#EB001B] opacity-90" data-id="element-191"></div>
        <div className="w-5 h-5 rounded-full bg-[#F79E1B] -ml-2.5 opacity-90" data-id="element-192"></div>
        <span className="text-[#333] text-xs font-bold ml-1.5" data-id="element-193">Mastercard</span>
      </div>
      {/* Amex */}
      <div className="flex items-center bg-[#007BC1] px-3 py-1.5 rounded-lg" data-id="element-194">
        <span className="text-white text-xs font-bold tracking-wide" data-id="element-195">AMEX</span>
      </div>
    </div>;
}
function OrderBump({
  checked,
  setChecked,
  bumpARS,
  bumpStrikeARS,
  formatARS
}: {
  checked: boolean;
  setChecked: (v: boolean) => void;
  bumpARS: number;
  bumpStrikeARS: number;
  formatARS: (n: number) => string;
}) {
  return <div className="w-full mt-6" data-id="element-196">
      <button onClick={() => setChecked(!checked)} className={`w-full text-left rounded-2xl border-2 transition-all duration-300 overflow-hidden ${checked ? 'border-mostaza bg-mostaza/10 shadow-lg shadow-mostaza/20' : 'border-mostaza/60 bg-white/5'}`} data-id="element-197">
        {/* Checkbox CTA — ARRIBA del mockup para captura inmediata */}
        <div className={`flex items-center gap-3 px-5 pt-5 pb-4 border-b border-white/10 ${!checked ? 'animate-pulse-cta' : ''}`} data-id="element-198">
          <div className={`w-8 h-8 rounded-md border-2 flex items-center justify-center flex-shrink-0 transition-all duration-200 ${checked ? 'bg-mostaza border-mostaza' : 'border-mostaza bg-mostaza/20'}`} data-id="element-199">
            {checked ? <Check className="w-5 h-5 text-marron" strokeWidth={3} data-id="element-200" /> : <span className="text-mostaza text-lg font-black leading-none" data-id="element-201">
                +
              </span>}
          </div>
          <p className={`text-sm font-bold transition-colors leading-snug ${checked ? 'text-mostaza' : 'text-white'}`} data-id="element-202">
            {checked ? `✅ ¡Agregado a tu pedido! (+$${formatARS(bumpARS)} ARS)` : `👆 SÍ — Agregar el Reinicio Antiinflamatorio de 7 Días (PDF) por solo $${formatARS(bumpARS)} ARS más →`}
          </p>
        </div>

        {/* Mockup — debajo del CTA */}
        <div className="flex justify-center pt-5 px-5" data-id="element-203">
          <img src="https://cdn.magicpatterns.com/uploads/4bE6BCVVUceL3DtXaWCA7c/order_bump_detox-Photoroom.png" alt="Guía Detox Natural de 7 Días (PDF)" className="w-52 h-auto object-contain drop-shadow-xl" data-id="element-204" />
        </div>

        {/* Copy + precio */}
        <div className="p-5" data-id="element-205">
          <div className="text-center mb-4" data-id="element-206">
            <span className="text-mostaza text-xs font-bold uppercase tracking-widest" data-id="element-207">
              ⚡ AGREGÁ ESTO A TU PEDIDO — OFERTA ÚNICA
            </span>
            <h4 className="text-white font-heading font-bold text-lg leading-tight mt-1 mb-1" data-id="element-208">
              Reinicio Antiinflamatorio de 7 Días{' '}
              <span className="text-mostaza" data-id="element-209">(PDF)</span>
            </h4>
            <div className="flex items-center justify-center gap-3 mt-2" data-id="element-210">
              <span className="text-white/40 text-sm line-through" data-id="element-211">
                ${formatARS(bumpStrikeARS)} ARS
              </span>
              <span className="text-mostaza font-bold text-xl" data-id="element-212">
                ${formatARS(bumpARS)} ARS
              </span>
            </div>
          </div>

          <p className="text-crema/75 text-sm leading-relaxed" data-id="element-213">
            <strong className="text-white" data-id="element-214">
              Tu cuerpo ya tiene lo que necesita para sanar. Estos 7 días lo
              preparan para que cada receta del manual digital haga el doble de
              efecto — desde la primera semana.
            </strong>{' '}
            Licuados, infusiones y caldos depurativos con ingredientes simples
            que ya tenés en casa. Sin ayunos, sin hambre, sin complicaciones.
          </p>
        </div>
      </button>
    </div>;
}
export function PricingSection() {
  const [orderBumpChecked, setOrderBumpChecked] = useState(false);
  // Use Hotmart's exact prices (most reliable)
  const coreARS = 27395;
  const totalWithBumpARS = 38675;
  const bumpARS = totalWithBumpARS - coreARS; // = 11,280
  const bumpStrikeARS = 16100;
  const totalARS = orderBumpChecked ? totalWithBumpARS : coreARS;
  const totalUSD = orderBumpChecked ? 24 : 17;
  const formatARS = (n: number) => n.toLocaleString('es-AR', {
    minimumFractionDigits: 0
  });
  return <section id="oferta" className="py-20 bg-white" data-id="element-215">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="max-w-6xl mx-auto bg-gradient-to-br from-marron to-[#0f2214] rounded-3xl shadow-2xl overflow-hidden text-white p-8 sm:p-16 text-center relative" data-id="element-217">
          <div className="inline-block text-mostaza text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-4" data-id="element-218">
            OFERTA ESPECIAL — TIEMPO LIMITADO
          </div>

          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-mostaza mb-4" data-id="element-219">
            Todo lo que Recibís Hoy
          </h2>

          <p className="text-crema/80 mb-8 max-w-2xl mx-auto" data-id="element-220">
            Un sistema completo de sanación natural con herramientas que podés
            usar desde hoy mismo
          </p>

          <ProductMockup data-id="element-221" />

          {/* Stack list — full width */}
          <div className="bg-white/5 rounded-2xl p-6 sm:p-8 mb-8 text-left border border-white/10" data-id="element-222">
            <ul className="space-y-0" data-id="element-223">
              {/* Item 1 */}
              <li className="flex gap-5 items-start border-b border-white/10 pb-7 mb-7" data-id="element-224">
                <div className="w-12 h-12 rounded-xl bg-[#1a6b2f] flex items-center justify-center flex-shrink-0 text-2xl mt-0.5" data-id="element-225">
                  📘
                </div>
                <div className="flex-1 min-w-0" data-id="element-226">
                  <strong className="block text-base sm:text-lg text-white mb-2 leading-snug" data-id="element-227">
                    El Manual Digital de Sanación Natural{' '}
                    <span className="text-mostaza font-bold" data-id="element-228">(PDF)</span>
                  </strong>
                  <span className="block text-sm text-crema/70 leading-relaxed mb-3" data-id="element-229">
                    100+ recetas ancestrales organizadas por síntoma, con la
                    explicación científica de cada sinergia herbal
                  </span>
                  <span className="inline-block text-mostaza/60 text-sm font-bold line-through" data-id="element-230">
                    Valor: $240.000 ARS
                  </span>
                </div>
              </li>

              {/* Item 2 */}
              <li className="flex gap-5 items-start border-b border-white/10 pb-7 mb-7" data-id="element-231">
                <div className="w-12 h-12 rounded-xl bg-oliva flex items-center justify-center flex-shrink-0 text-2xl mt-0.5" data-id="element-232">
                  🌱
                </div>
                <div className="flex-1 min-w-0" data-id="element-233">
                  <strong className="block text-base sm:text-lg text-white mb-2 leading-snug" data-id="element-234">
                    BONO #1: Guía del Jardín Medicinal{' '}
                    <span className="text-mostaza font-bold" data-id="element-235">(PDF)</span>
                  </strong>
                  <span className="block text-sm text-crema/70 leading-relaxed mb-3" data-id="element-236">
                    ¿No tenés jardín? No importa. Aprendé a cultivar tus propias
                    hierbas en macetas, en el balcón o en el alféizar — y nunca
                    más dependas de la verdulería para tener remedios frescos en
                    casa.
                  </span>
                  <span className="inline-block text-mostaza/60 text-sm font-bold line-through" data-id="element-237">
                    Valor: $40.000 ARS
                  </span>
                </div>
              </li>

              {/* Item 3 */}
              <li className="flex gap-5 items-start" data-id="element-238">
                <div className="w-12 h-12 rounded-xl bg-terracota flex items-center justify-center flex-shrink-0 text-2xl mt-0.5" data-id="element-239">
                  🆘
                </div>
                <div className="flex-1 min-w-0" data-id="element-240">
                  <strong className="block text-base sm:text-lg text-white mb-2 leading-snug" data-id="element-241">
                    BONO #2: Herbal SOS — Respuesta Inmediata{' '}
                    <span className="text-mostaza font-bold" data-id="element-242">(PDF)</span>
                  </strong>
                  <span className="block text-sm text-crema/70 leading-relaxed mb-3" data-id="element-243">
                    Para cuando el dolor, la hinchazón o el insomnio te agarran
                    de sorpresa. 20 recetas de emergencia listas en menos de 5
                    minutos, con ingredientes que ya tenés en casa — sin
                    esperar, sin farmacia.
                  </span>
                  <span className="inline-block text-mostaza/60 text-sm font-bold line-through" data-id="element-244">
                    Valor: $32.000 ARS
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <div className="border-t-2 border-dashed border-white/20 my-8" data-id="element-245"></div>

          <div className="flex justify-between items-center mb-4 text-crema/70" data-id="element-246">
            <span data-id="element-247">Valor total del paquete:</span>
            <span className="line-through decoration-red-500 decoration-2" data-id="element-248">
              $312.000 ARS
            </span>
          </div>

          <div className="flex justify-between items-center mb-8" data-id="element-249">
            <span className="text-xl sm:text-2xl font-bold text-white" data-id="element-250">
              Tu precio hoy:
            </span>
            <div className="text-right" data-id="element-251">
              <div className="text-4xl sm:text-5xl font-bold text-mostaza leading-none transition-all duration-500" data-id="element-252">
                ${formatARS(totalARS)} <span className="text-2xl" data-id="element-253">ARS</span>
              </div>
              {orderBumpChecked && <div className="text-xs text-mostaza/80 mt-1 font-semibold animate-fade-in" data-id="element-254">
                  Incluye Reinicio Antiinflamatorio ✅
                </div>}
            </div>
          </div>

          <a href={orderBumpChecked ? 'https://pay.hotmart.com/V104621465A?off=qot4mmfn' : 'https://pay.hotmart.com/V104621465A?off=kyiadr1i'} onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              value: totalUSD,
              currency: 'USD',
              content_name: orderBumpChecked ? 'Manual Digital + Reinicio Antiinflamatorio' : 'Manual Digital de Sanación Natural'
            });
          }
        }} className="block w-full bg-oliva hover:bg-oliva-dark text-white font-bold text-xl py-5 rounded-xl shadow-xl transition-all transform hover:-translate-y-1" data-id="element-255">
            <span className="flex items-center justify-center" data-id="element-256">
              🌿 SÍ — QUIERO MI MANUAL DIGITAL
              <ArrowRight className="ml-2 w-6 h-6" data-id="element-257" />
            </span>
            <span className="block text-sm font-normal mt-1 opacity-80" data-id="element-258">
              Acceder ahora con 75% de descuento + 2 guías de regalo
            </span>
          </a>

          {/* Payment logos */}
          <PaymentLogos data-id="element-259" />

          {/* Order Bump */}
          <OrderBump checked={orderBumpChecked} setChecked={setOrderBumpChecked} bumpARS={bumpARS} bumpStrikeARS={bumpStrikeARS} formatARS={formatARS} data-id="element-260" />

          <p className="mt-6 text-sm text-crema/60 flex items-center justify-center gap-2" data-id="element-261">
            <ShieldCheck className="w-4 h-4" data-id="element-262" />
            Pago 100% seguro · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}